var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M25.781 37.879c1.459 0 2.552-.368 3.282-1.104.729-.735 1.093-1.826 1.093-3.271V6.394c0-1.445-.364-2.539-1.093-3.28C28.332 2.37 27.24 2 25.78 2H14.375c-1.445 0-2.536.371-3.271 1.113C10.368 3.855 10 4.95 10 6.395v27.109c0 1.445.368 2.536 1.104 3.271.735.736 1.826 1.104 3.271 1.104h11.406zm-.058-1.016h-11.29c-1.171 0-2.03-.27-2.578-.81-.546-.54-.82-1.397-.82-2.569V6.394c0-1.171.274-2.027.82-2.568.547-.54 1.407-.81 2.579-.81h.586v.507c0 .287.08.515.244.684.162.17.38.254.654.254h8.32c.274 0 .495-.085.664-.254.17-.17.254-.397.254-.684v-.507h.567c1.185 0 2.05.27 2.597.81.547.54.82 1.397.82 2.569v27.09c0 1.171-.273 2.027-.82 2.568-.547.54-1.412.81-2.597.81zm-1.055-1.172c.13 0 .244-.052.342-.156a.483.483 0 00.146-.332.502.502 0 00-.146-.351.454.454 0 00-.342-.157h-9.18c-.13 0-.24.052-.332.157a.497.497 0 000 .683.426.426 0 00.332.156h9.18z"
  }))));
}

export default SvgMobile;